import { fetchMlsData, saveContactOpportunityProperty } from '../services/opportunities.services';
import { isResponseSuccess } from 'helpers';
import { showServerResponse } from './modals.actions';
import { PROPERTY } from '_constants';

export const getMlsInfo = (mlsId, state) => async (dispatch) => {
  const response = await dispatch(fetchMlsData(mlsId, state));
  if (isResponseSuccess(response)) {
    return response.data;
  }
};

export const saveOpportuntiyProperty = (opportunity, property) => async (dispatch) => {
  opportunity.contactProperty = property;
  opportunity.contactProperty.ContactKey = opportunity.contactKey;
  try {
    dispatch({ type: PROPERTY.START_SAVING_OPPORTUNITY_PROPERTY });
    const response = await dispatch(saveContactOpportunityProperty(opportunity.contactKey, opportunity.opportunityKey, opportunity));
    dispatch(showServerResponse(response, 'Property Added Successfully', 'Error Adding Property'));
    return response;
  } catch (err) {
    console.error(err);
    dispatch({ type: PROPERTY.ERROR_SAVING_OPPORTUNITY_PROPERTY, payload: err });
    return Promise.reject(err);
  } finally {
    dispatch({ type: PROPERTY.END_SAVING_OPPORTUNITY_PROPERTY });
  }
};
